import { bool, func, string } from "prop-types";
import React from "react";
import { twMerge } from "tailwind-merge";

import { withTabNavigation } from "@hoc/withTabNavigation";

const Option = withTabNavigation("p");

const Switch = ({
  checked = false,
  onChange,
  selectedText,
  unselectedText,
}) => {
  return (
    <div className="min-w-75 sm:min-w-90">
      <input
        className="size-0 opacity-0"
        id="switch"
        onChange={onChange}
        tabIndex={-1}
        type="checkbox"
        value={checked}
      />
      <div className="flex justify-center items-center relative transition duration-100">
        <label
          className="h-11 w-full rounded-full relative mt-7 mb-16 cursor-pointer bg-primaryDark border-4 border-primaryDark"
          htmlFor="switch"
        >
          <div
            className={twMerge(
              "h-full rounded-full absolute w-1/2 bg-white transition duration-300",
              checked ? "translate-x-full" : "translate-y-0"
            )}
          />
          <div className="flex justify-around items-center size-full absolute select-none text-xs/1 font-semibold">
            <Option
              className={twMerge(
                "transition duration-300 capitalize",
                !checked ? "text-primaryDark" : "text-white"
              )}
            >
              {selectedText}
            </Option>
            <Option
              className={twMerge(
                "transition duration-300 capitalize",
                checked ? "text-primaryDark" : "text-white"
              )}
            >
              {unselectedText}
            </Option>
          </div>
        </label>
      </div>
    </div>
  );
};

Switch.propTypes = {
  checked: bool.isRequired,
  onChange: func.isRequired,
  selectedText: string,
  unselectedText: string,
};

export default Switch;
